import React from "react"
import { useGetUser } from "../../hooks/useGetUser";
import {useFetchUser} from "../../lib/users/useFetchUser";

type UserNameProps = {
    id: string
}

export function UserName({id}: UserNameProps) {
    const {user, error, isLoading} = useGetUser(id)



    if (isLoading) {
        return <div>Loading...</div>
    }

    if (error) return <div>Error</div>


    if (user) {
        return <div>
            {user.profile.firstName} {user.profile.lastName}
        </div>
    }

    return null
}